module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALQAAAASCAYAAADyiPTBAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAtKADAAQAAAABAAAAEgAAAACKet51AAAAuUlEQVRoBe3UsQ2DMBgFYRtZQUjU2THzZBNWoWYLKgqTFdy8U5AuNfmf9HGirp/tLv6GBY79e5ZS1+E/+CAqMKFrjikQFjDoMLDnWQGDZr1dCwsYdBjY86yAQbPeroUFDDoM7HlWwKBZb9fCAgYdBvY8K2DQrLdrYQGDDgN7nhUwaNbbtbCAQYeBPc8KGDTr7VpYwKDDwJ5nBQya9XYtLGDQYWDPswKttPZmJ5+9tly91/nlh+BPX+MPpusIvTn6P2MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banda_mineduc.png
// module id = 3i1x
// module chunks = 1